/*
 *###############################################################################
 *Module Name                   : LocationMasterCDContent.js                   #
 *Purpose of the Module         :                                              #
 *Description of the Module     :                                              #
 *Original Author               : Chathura Prabashwara                         #
 *Date                          : Monday , Octomber 4th 2021, 10:10:07 am      #
 *Copyright © 2021 myPOS Software Solution (Pvt) Ltd.                          #
 *###############################################################################
 */

import React, { useState, useEffect, Alert } from "react"
import { CardText, Col, Row } from "reactstrap"
import DPTextBox from "../../../framework/components/DPTextBox"
import DPDropDown from "framework/components/DPDropDown"

const LocationMasterCDContent = ({
  Loc_Add,
  Loc_AddOnChange,
  Loc_Add2,
  Loc_Add2onChange,
  Loc_Add3,
  Loc_Add3OnChange,
  Loc_City,
  Loc_CityonChange,
  Loc_Area,
  Loc_AreaOnChange,
  Loc_District,
  Loc_DistrictonChange,
  Loc_Prov,
  Loc_ProvonChange,
  Loc_Country,
  Loc_CountryonChange,
  Loc_OPMNG,
  Loc_OPMNGOnChange,
  Loc_MNG,
  Loc_MNGOnChange,
  Loc_Mobile1,
  Loc_Mobile1OnChange,
  Loc_Mobile2,
  Loc_Mobile2OnChange,
  Loc_Phone1,
  Loc_Phone1OnChange,
  Loc_Phone2,
  Loc_Phone2OnChange,
  Loc_Fax,
  Loc_FaxOnChange,
  Loc_Email,
  Loc_EmailOnChange,
  disabled,
  show,
  AlertMsg,
  AlertColor,
  ErrorMsg,
  hideFields,
  disabledFields
}) => {

  const [area, SetArea] = useState([])
  //  const [area, SetArea] = useState([{  }])
  const [city, SetCity] = useState([])
  const [district, SetDistrict] = useState([])
  const [province, SetProvince] = useState([])
  const [country, SetCountry] = useState([])
  const [OperationManger, SetOperationManger] = useState([])
  const [Manager, SetManager] = useState([])


  useEffect(() => {
    const authToken = localStorage.getItem("authToken")
    /**************get area data */
    function getArea() {
      var requestOptions = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authToken}`
        },
        redirect: 'follow'
      };
      const ApiURL = window.Links.ApiURL
      fetch(`${ApiURL}SupplierArea/Select/`, requestOptions)
        .then(response => response.json())
        .then(result => {
          SetArea(result.data)
          let dt = result.data
        }).catch(error => console.log('error', error));
    }
    /**************get area data  End*/

    getArea()

    var requestOptions = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authToken}`
      },
      redirect: 'follow'
    };
    const ApiURL = window.Links.ApiURL
    fetch(`${ApiURL}common/Country`, requestOptions)
      .then(response => response.json())
      .then(result => {
        SetCountry(result.data)
        let dt = result.data

      }).catch(error => console.log('error', error));
    var requestOptions = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authToken}`
      },
      redirect: 'follow'
    };

    fetch(`${ApiURL}common/Province`, requestOptions)
      .then(response => response.json())
      .then(result => {
        SetProvince(result.data)
        let dt = result.data

      }).catch(error => console.log('error', error));
    var requestOptions = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authToken}`
      },
      redirect: 'follow'
    };


    fetch(`${ApiURL}common/City`, requestOptions)
      .then(response => response.json())
      .then(result => {
        SetCity(result.data)
        let dt = result.data

      }).catch(error => console.log('error', error));
    var requestOptions = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authToken}`
      },
      redirect: 'follow'
    };

    fetch(`${ApiURL}user/select`, requestOptions)
      .then(response => response.json())
      .then(result => {
        SetOperationManger(result.data)
        let dt = result.data

      }).catch(error => console.log('error', error));
    var requestOptions = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authToken}`
      },
      redirect: 'follow'
    };

    fetch(`${ApiURL}user/select`, requestOptions)
      .then(response => response.json())
      .then(result => {
        SetManager(result.data)
        let dt = result.data

      }).catch(error => console.log('error', error));
    var requestOptions = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authToken}`
      },
      redirect: 'follow'
    };

    fetch(`${ApiURL}common/District`, requestOptions)
      .then(response => response.json())
      .then(result => {
        SetDistrict(result.data)
        let dt = result.data

      }).catch(error => console.log('error', error));
  }, [])



  return (
    <React.Fragment>
      <div>
        <Row>
          <Col sm="12">
            <CardText className="mb-0">
              <Row>
                {show ? (
                  <Alert color={AlertColor} role="alert">
                    {AlertMsg}
                    <br />
                    <small>{ErrorMsg}</small>
                  </Alert>
                ) : null}
                <Col sm={12} md={5} className="mb-5-sm">
                  <div hidden={hideFields && disabledFields.includes("LOC_ADD1") ? true : false}>
                    <DPTextBox
                      rowClass="mb-4-sm"
                      labelText="Address"
                      textType="text"
                      placeholder="Address Line 1"
                      maxLength="100"
                      value={Loc_Add}
                      onChange={Loc_AddOnChange}
                      disabled={disabled || disabledFields.includes("LOC_ADD1")}

                    />
                  </div>
                  <div hidden={hideFields && disabledFields.includes("LOC_ADD2") ? true : false}>
                    <DPTextBox
                      rowClass="mb-4-sm"
                      labelText="&nbsp;"
                      textType="text"
                      placeholder="Address Line 2"
                      maxLength="100"
                      value={Loc_Add2}
                      onChange={Loc_Add2onChange}
                      disabled={disabled || disabledFields.includes("LOC_ADD2")}

                    />
                  </div>
                  <div hidden={hideFields && disabledFields.includes("LOC_ADD3") ? true : false}>
                    <DPTextBox
                      rowClass="mb-7-sm"
                      labelText="&nbsp;"
                      textType="text"
                      placeholder="Address Line 3"
                      maxLength="100"
                      value={Loc_Add3}
                      onChange={Loc_Add3OnChange}
                      disabled={disabled || disabledFields.includes("LOC_ADD3")}

                    />
                  </div>
                  <div hidden={hideFields && disabledFields.includes("LOC_TOWN") ? true : false}>
                    <DPDropDown
                      labelText="City"
                      rowClass="mb-4-sm"
                      optionGroup={city}
                      selectedGroup={Loc_City}
                      onChange={Loc_CityonChange}
                      disabled={disabled || disabledFields.includes("LOC_TOWN")}
                    />
                  </div>
                  <div hidden={hideFields && disabledFields.includes("LOC_AREA") ? true : false}>
                    <DPDropDown
                      labelText="Area"
                      rowClass="mb-4-sm"
                      optionGroup={area}
                      selectedGroup={Loc_Area}
                      onChange={Loc_AreaOnChange}
                      disabled={disabled || disabledFields.includes("LOC_AREA")}
                    />
                  </div>
                  <div hidden={hideFields && disabledFields.includes("LOC_DISTRICT") ? true : false}>
                    <DPDropDown
                      labelText="District"
                      rowClass="mb-4-sm"
                      optionGroup={district}
                      selectedGroup={Loc_District}
                      onChange={Loc_DistrictonChange}
                      disabled={disabled || disabledFields.includes("LOC_DISTRICT")}
                    />
                  </div>
                  <div hidden={hideFields && disabledFields.includes("LOC_PROV") ? true : false}>
                    <DPDropDown
                      labelText="Province"
                      rowClass="mb-4-sm"
                      optionGroup={province}
                      selectedGroup={Loc_Prov}
                      onChange={Loc_ProvonChange}
                      disabled={disabled || disabledFields.includes("LOC_PROV")}
                    />
                  </div>
                  <div hidden={hideFields && disabledFields.includes("LOC_COUNTRY") ? true : false}>
                    <DPDropDown
                      labelText="Country"
                      rowClass="mb-4-sm"
                      optionGroup={country}
                      selectedGroup={Loc_Country}
                      onChange={Loc_CountryonChange}
                      disabled={disabled || disabledFields.includes("LOC_COUNTRY")}
                    />
                  </div>
                </Col>
                <Col sm={12} md={5} className="mb-5-sm">
                  <div hidden={hideFields && disabledFields.includes("LOC_OPMNG") ? true : false}>
                    <DPDropDown
                      labelText="Operations Manager"
                      rowClass="mb-4-sm"
                      optionGroup={OperationManger}
                      selectedGroup={Loc_OPMNG}
                      onChange={Loc_OPMNGOnChange}
                      disabled={disabled || disabledFields.includes("LOC_OPMNG")}
                    />
                  </div>
                  <div hidden={hideFields && disabledFields.includes("LOC_MNG") ? true : false}>
                    <DPDropDown
                      labelText="Manager"
                      rowClass="mb-4-sm"
                      optionGroup={Manager}
                      selectedGroup={Loc_MNG}
                      onChange={Loc_MNGOnChange}
                      disabled={disabled || disabledFields.includes("LOC_MNG")}
                    />
                  </div>
                  <div hidden={hideFields && disabledFields.includes("LOC_MOBILE1") ? true : false}>
                    <DPTextBox
                      rowClass="mb-4-sm"
                      labelText="Mobile"
                      textType="tel"
                      maxLength="10"
                      placeholder="Mobile 1"
                      value={Loc_Mobile1}
                      onChange={Loc_Mobile1OnChange}
                      disabled={disabled || disabledFields.includes("LOC_MOBILE1")}

                    />
                  </div>
                  <div hidden={hideFields && disabledFields.includes("LOC_MOBILE2") ? true : false}>
                    <DPTextBox
                      rowClass="mb-4-sm"
                      labelText="&nbsp;"
                      textType="tel"
                      maxLength="10"
                      placeholder="Mobile 2"
                      value={Loc_Mobile2}
                      onChange={Loc_Mobile2OnChange}
                      disabled={disabled || disabledFields.includes("LOC_MOBILE2")}

                    />
                  </div>
                  <div hidden={hideFields && disabledFields.includes("LOC_PHONE2") ? true : false}>
                    <DPTextBox
                      rowClass="mb-4-sm"
                      labelText="Phone"
                      textType="tel"
                      maxLength="10"
                      placeholder="Phone 1"
                      value={Loc_Phone1}
                      onChange={Loc_Phone1OnChange}
                      disabled={disabled || disabledFields.includes("LOC_PHONE1")}

                    />
                  </div>
                  <div hidden={hideFields && disabledFields.includes("LOC_PHONE2") ? true : false}>
                    <DPTextBox
                      rowClass="mb-4-sm"
                      labelText="&nbsp;"
                      textType="tel"
                      maxLength="10"
                      placeholder="Phone 2"
                      value={Loc_Phone2}
                      onChange={Loc_Phone2OnChange}
                      disabled={disabled || disabledFields.includes("LOC_PHONE2")}

                    />
                  </div>
                  <div hidden={hideFields && disabledFields.includes("LOC_FAX") ? true : false}>
                    <DPTextBox
                      rowClass="mb-4-sm"
                      labelText="Fax"
                      textType="tel"
                      maxLength="40"
                      value={Loc_Fax}
                      onChange={Loc_FaxOnChange}
                      disabled={disabled || disabledFields.includes("LOC_FAX")}

                    />
                  </div>
                  <div hidden={hideFields && disabledFields.includes("LOC_EMAIL") ? true : false}>
                    <DPTextBox
                      rowClass="mb-4-sm"
                      labelText="Email"
                      textType="text"
                      maxLength="40"
                      value={Loc_Email}
                      onChange={Loc_EmailOnChange}
                      disabled={disabled || disabledFields.includes("LOC_EMAIL")}

                    />
                  </div>
                </Col>
              </Row>
            </CardText>
          </Col>
        </Row>
      </div>
    </React.Fragment >
  )
}
export default LocationMasterCDContent